const TILE_SELECTOR = '.intermix-program__color-tile[data-slug][data-attribute]';

function attributeSelectName(attribute) {
  return `attribute_${attribute}`;
}

function findVariationSwatch(attribute, slug) {
  const selectName = attributeSelectName(attribute);
  const form = document.querySelector('form.variations_form');

  if (!form) {
    return null;
  }

  return (
    form.querySelector(`.variable-item[data-attribute_name="${selectName}"][data-value="${slug}"]`)
    || form.querySelector(`.variable-item[data-value="${slug}"]`)
  );
}

function syncOfferingSelection(form) {
  document.querySelectorAll(TILE_SELECTOR).forEach((tile) => {
    const swatch = findVariationSwatch(tile.dataset.attribute, tile.dataset.slug);
    tile.classList.toggle('is-selected', Boolean(swatch?.classList.contains('selected')));
  });
}

function initIntermixColorSwatches() {
  const tiles = [...document.querySelectorAll(TILE_SELECTOR)];

  if (!tiles.length) {
    return;
  }

  const form = document.querySelector('form.variations_form');

  tiles.forEach((tile) => {
    if (tile.dataset.intermixBound) {
      return;
    }

    tile.dataset.intermixBound = 'true';

    tile.addEventListener('click', () => {
      const swatch = findVariationSwatch(tile.dataset.attribute, tile.dataset.slug);

      if (!swatch) {
        return;
      }

      swatch.click();
      syncOfferingSelection(form);
    });
  });

  if (form) {
    form.addEventListener('change', () => syncOfferingSelection(form));
    form.addEventListener('click', (event) => {
      if (event.target.closest('.variable-item')) {
        window.requestAnimationFrame(() => syncOfferingSelection(form));
      }
    });
    syncOfferingSelection(form);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initIntermixColorSwatches);
} else {
  initIntermixColorSwatches();
}
